export enum ActionItem {
    MatchOffers = 1,
    RequestForDonorReview = 2,
    XMResults = 3,
    DonorClearance = 4,
    EmergencySwapNotification = 5,
    TransplantPickup = 6,
    TransplantDelivery = 7,
    DashContactDue = 8,
    Preselects = 10,
    Invoice = 11,
    Rccap = 12,
    ActiveRecipientDataCompliance = 13,
    ActiveDonorDataCompliance = 14,
    LogisticsKickoffCalls = 15,
    MissingPostTransplantData = 16,
    MissingCenterProfileData = 17,
    ConfirmReimbursementDonations = 19,
    ConfirmDashDonations = 20,
    MissingVoucherHolders = 21,
    CustomLogistics = 22,
    DonationDateRangeConflict = 24,
    DonorEval = 25,
    PendingRecipientReferrals = 27,
    LostChainStarters = 28,
    PendingPatientReferrals = 29,
    FinalXmReults = 30,
    WageAndTravelRequests = 31,
    PostTransplantRecipientDataCompliance = 32,
    PostTransplantDonorDataCompliance = 33,
    PostTransplantRdnDonorDataCompliance = 34,
    VoucherDonors = 35,
    HasAbWaitListPatients = 36,
    RemoteWorkupsNotBilled = 38,
    ActiveRdnDonorDataCompliance = 39,
    FlaggedForVoucherDonation = 40,
    OutstandingInternalDirectSwaps = 41,
    MissingVoucherConsents = 42,
    PendingPatientIntakeReferrals = 43,
    MicrositeDataCompliance = 44,
    OutstandingDonorReimbursements = 45,
    DonorsWithRemoteRecipient = 46,
    ImmunoFreeCandidates = 47,
    WaitListAnatomyCompliance = 48,
    AtRiskMortalityRecipients = 50,
    IsDiabeticRecipientFollowUps = 51,
    MicrositePatientsPendingApproval = 52,
    CenterContactPositions = 53,
    StrongBoxDataCompliance = 54,
    ConfirmSerologyBloodDraw = 55,
    ConfirmBloodDrawCompletion = 56,
    StagnantMicrositeUpdates = 57,
    LdPrioritization = 100,
    PassMissingRecipientProfile = 110,
    PackagingRemittance = 120,
    PendingPatientIntakeTransfers = 121
}